import Button from 'components/Button/Button.react';
import ChromeDropdown from 'components/ChromeDropdown/ChromeDropdown.react';
import Field from 'components/Field/Field.react';
import styles from 'components/Modal/Modal.scss';
import Label from 'components/Label/Label.react';
import Modal from 'components/Modal/Modal.react';
import React from 'react';

export default class RemoveColumnDialog extends React.Component {
  constructor(props) {
    super();
    this.state = {
      name: props.currentColumns[0],
    };

    this.handleKey = this.handleKey.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
  }

  componentDidMount() {
    document.body.addEventListener('keydown', this.handleKey);
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.handleKey);
  }

  onCloseClick() {
    this.props.onCancel();
  }

  handleKey(e) {
    const keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 27:
        this.onCloseClick(this);
        break;
    }
  }

  render() {
    let content = null;
    const columnsLength = this.props.currentColumns.length;
    const hasColumns = columnsLength > 0;
    if (hasColumns) {
      if (columnsLength === 1) {
        content = (
          <p className={styles.only}>You have only one custom column with name "<strong>{this.props.currentColumns}</strong>"</p>
        );
      } else {
        content = (
          <Field
            label={
              <Label
                text="Which column?" />
              }
            input={
              <ChromeDropdown
                value={this.state.name}
                options={this.props.currentColumns}
                onChange={name => this.setState({ name })} />
            } />
        );
      }
    }
    return (
      <Modal
        type={Modal.Types.DANGER}
        title="Delete a column"
        subtitle={hasColumns ? 'Be careful, this action cannot be undone!' : null}
        confirmText="Delete"
        cancelText="Cancel"
        onCancel={this.onCloseClick.bind(this)}
        onConfirm={() => {
          this.props.onConfirm(this.state.name);
        }}
        customFooter={hasColumns ? null :
        <div className={styles.customFooter}>
          <Button value="Okay, go back." onClick={this.props.onCancel} />
        </div>
        }>
        {hasColumns
          ?
            content
          :
            <p className={styles.only}>There are no removable columns on this class.</p>
        }
      </Modal>
    );
  }
}
